// 时间格式化
import { formatDate } from "../libs/tools";
/**
 * 格式化时间戳
 * @param {*} time 时间戳 13位或10位
 * @param {*} cut 分割符 -或/  汉字拼接传“年”
 * @param {*} flag 时间的时分秒是否需要 默认需要
 */
export default {
  beforeMount(el, { value: { time, cut, flag } }) {
    let string = formatDate(time, cut, flag);
    el.innerText = string;
  },
  updated(el, { value: { time, cut, flag } }) {
    let string = formatDate(time, cut, flag);
    el.innerText = string;
  }
};
